import { useContext } from "react";

import { AuthContext, IAuthContext } from "@/auth/AuthContext";

export default function useAuthentication(): IAuthContext | undefined {
	return useContext(AuthContext);
}
